import { forwardRef, useContext, useState, Fragment } from "react";
import {
    AppBar,
    Dialog,
    IconButton,
    Slide,
    Toolbar,
    Typography,
    Box
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ModuleContext } from "../../context/ModuleContext";
import { ModuleContainer } from "../ModuleContainer";
import { ManagedAccountContext } from "../../context/ManagedAccountContext";
import { ManagedAccountDetailPanel } from "./ManagedAccountDetailPanel";
import { CreateManagedAccount } from "../../operations/managed_accounts/CreateManagedAccount";
import { ManagedAccountOptionsMenu } from "./ManagedAccountOptionsMenu";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export const ManagedAccountContainer = () => {
    const { managedAccountModule, setManagedAccountModule } = useContext(ManagedAccountContext);

    const [module, setModule] = useState({
        isVisible: false,
        element: null,
        validated: false,
        validationError: null,
        userId: null,
        isLog: false,
    });

    const handleClose = () => {
        setManagedAccountModule((prev) => ({ ...prev, data: null, isOpen: false }));
    };

    return (
        <Dialog fullScreen open={managedAccountModule.isOpen} TransitionComponent={Transition}>
            <ModuleContext.Provider value={{ module, setModule }}>
                <ModuleContainer />

                <AppBar sx={{ position: "relative", backgroundColor: "#A60F2D", color: "white" }}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            {managedAccountModule.mode === "create"
                                ? "Create Managed Account"
                                : `Managed Account: ${managedAccountModule.upn}`}
                        </Typography>
                    </Toolbar>
                </AppBar>

                {managedAccountModule.mode === "read" && (
                    <Box sx={{ display: "flex", flexDirection: "row", p: 2, gap: 3, alignItems: "flex-start", flex: 1, minHeight: 0, overflowY: "auto" }}>
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                            <ManagedAccountDetailPanel />
                        </Box>
                        {managedAccountModule.data !== null && (
                            <Box sx={{ flexShrink: 0 }}>
                                <ManagedAccountOptionsMenu />
                            </Box>
                        )}
                    </Box>
                )}

                {managedAccountModule.mode === "create" && (
                    <Box sx={{ width: "100%", p: 3, flex: 1, minHeight: 0, overflowY: "auto" }}>
                        <CreateManagedAccount />
                    </Box>
                )}
            </ModuleContext.Provider>
        </Dialog>
    );
};